import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export interface DecimalRangeOptions {
  min: number;
  max: number;
  maxDecimals: number;
}

export const decimalRangeValidator = ({ min, max, maxDecimals }: DecimalRangeOptions): ValidatorFn => {
  const pattern = new RegExp(`^-?\\d+(?:[.,]\\d{1,${maxDecimals}})?$`);

  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value === null || control.value === undefined || `${control.value}`.trim() === "") {
      return null;
    }

    const value = `${control.value}`.trim();

    if (!pattern.test(value)) {
      return { decimalFormat: { maxDecimals } };
    }

    const parsed = Number(value.replace(",", "."));

    return parsed < min || parsed > max ? { decimalRange: { min, max } } : null;
  };
};
